import { FC, useContext } from 'react';
import { MailFolderDto, MailOutBoundConfigDTO } from '../../../Types/MailT';
import NavigationLink from '../../../Atoms/Navigation/NavigationLink';
import EmailBoxCounter from '../EmailBoxCounter';
import { EmailBoxContext } from '../../../Service/Context/EmailBoxContext';
import { MailS } from '../../../Service/MailS';

interface Props {
  config: MailOutBoundConfigDTO;
  folder: MailFolderDto;
  closeNavBar: () => void;
}

const DefaultFolder: FC<Props> = ({ folder, config, closeNavBar }) => {
  const { children } = folder;

  return (
    <>
      {children?.map((f) => (
        <Folder key={f.fullName} config={config} folder={f} closeNavBar={closeNavBar} />
      ))}
    </>
  );
};

const Folder: FC<Props> = ({ folder, config, closeNavBar }) => {
  const { openedFolder, openFolder } = useContext(EmailBoxContext);
  const { id: configId } = config;
  const { fullName: folderName, configId: folderConfigId } = openedFolder ?? {};
  const { name, fullName, children, unreadMessages, hasChildren } = folder;

  return (
    <NavigationLink
      compact
      label={MailS.getFolderLabel(name)}
      defaultOpened={hasChildren}
      active={folderName === fullName && configId === folderConfigId}
      onClick={() => {
        if (!hasChildren) {
          openFolder({ ...folder, src: 'IMAP', configId });
          closeNavBar();
        }
      }}
      variant="filled"
      rightSection={
        // eslint-disable-next-line no-nested-ternary
        hasChildren ? null : <EmailBoxCounter count={unreadMessages} />
      }
    >
      {hasChildren
        ? children?.map((f) => <Folder key={f.fullName} folder={f} config={config} closeNavBar={closeNavBar} />)
        : null}
    </NavigationLink>
  );
};

export default DefaultFolder;
